// extracted by mini-css-extract-plugin
export default {"root":"HY3vv","menu":"_2Ak8b"};